import React, { useContext } from "react";

// To push history
import { useHistory } from "react-router-dom";

//components
import IconContent from "./IconContent";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

const QueryIcon = ({ moduleName }) => {
  //global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to use history
  const history = useHistory();

  //sets the app state to this module so the app knows what to display
  //in the content area
  const handleClick = () => {
    setState({
      ...state,
      currentModule: moduleName,
    });

    localStorage.setItem("currentModule", JSON.stringify(moduleName));

    history.push(`/console/${moduleName.replace(" ", "-")}`);
  };

  if (!state.ignoreModules.includes(moduleName)) {
    return (
      <IconContent
        handleClick={handleClick}
        state={state}
        moduleName={moduleName}
      />
    );
  } else {
    return null;
  }
};

export default QueryIcon;
